import React from 'react';
import PropTypes from 'prop-types';
const moment = require('moment');

const Strings = require('../../../../app/shared/Strings');
import AccessibleDatePicker from './AccessibleDatePicker';

const propTypes = {
    id: PropTypes.string.isRequired,
    minDate: PropTypes.instanceOf(moment),
    date: PropTypes.object, // can be null (if clearable) todo: more specific (instanceof Moment?)
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    labelTime: PropTypes.string, // this is sr-only
    onRemove: PropTypes.func,
    readOnly: PropTypes.bool,
    allowRemove: PropTypes.bool,
    isClearable: PropTypes.bool,
    defaultHour: PropTypes.number,
    defaultMinute: PropTypes.number,
    timezoneDisplay: PropTypes.string,
    labelClassName: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    minDate: moment(),
    label: Strings['en'].common.PICK_DATE,
    labelTime: Strings['en'].common.PICK_TIME,
    readOnly: false,
    allowRemove: true,
    isClearable: false,
    defaultHour: 0,
    defaultMinute: 0,
    timezoneDisplay: '',
    labelClassName: '',
    className: 'datetimePicker',
};

function DateTimePicker(props) {
    const datePickerId = `${props.id}-date-input`;
    const timePickerId = `${props.id}-time-input`;
    
    function _trimToMinute(date) {
        date.second(0);
        date.millisecond(0);
        return date;
    }

    function _onDateChange(date) {
        if ((date === null) && props.isClearable) {
            props.onChange(date);
            return;
        }

        let newDate = moment(date);
        //keep current time intact
        if (props.date) {
            newDate.hour(props.date.hour());
            newDate.minute(props.date.minute());
        }
        else {
            newDate.hour(props.defaultHour);
            newDate.minute(props.defaultMinute);
        }

        newDate = _trimToMinute(newDate);
        if (newDate < props.minDate) {
            //todo: display some sort of feedback?
            newDate = props.minDate;
        }

        props.onChange(newDate);
    }

    function _onTimeChange(e/*, time*/) {
        const time = e.target.value.split(':');
        let newDate = moment(props.date);
        newDate.hour(time[0]);
        newDate.minute(time[1]);
        newDate = _trimToMinute(newDate);

        if (newDate < props.minDate) {
            //todo: display some sort of feedback
            return;
        }

        props.onChange(newDate)
    }

    const dateIsSameDayAsMin = (!!props.date && !!props.minDate) && moment(props.date).isSame(props.minDate, 'day');
    
    return (
        <div
            className={`${props.className}${props.readOnly ? ' disabled' : ''}`}
        >
            <label
                className={`block margin-bottom-sm ${props.labelClassName}`}
                htmlFor={datePickerId}
            >
                {props.label}
            </label>
            <AccessibleDatePicker
                id={datePickerId}
                selected={props.date ? props.date.toDate() : props.date /*null case*/}
                required={!props.isClearable}
                onChange={_onDateChange}
                minDate={props.minDate}
                disabled={props.readOnly}
            />
            <label
                className="sr-only"
                htmlFor={timePickerId}
            >
                {props.labelTime}
            </label>
            <input
                id={timePickerId}
                className="datetimePicker__time"
                type="time"
                min={(!props.isClearable && dateIsSameDayAsMin) ? props.minDate.format("HH:mm:ss") : null}
                value={props.date ? props.date.format("HH:mm") : ''}
                required={!props.isClearable}
                onChange={_onTimeChange}
                readOnly={props.readOnly}
                disabled={props.readOnly}
            />
            {(!!props.timezoneDisplay) &&
                <span className="datetimePicker__timezone">{props.timezoneDisplay}</span>
            }
            {(!!props.onRemove && props.allowRemove) &&
                <button
                    className="bare-text-button glyph fr"
                    disabled={props.readOnly}
                    onClick={props.onRemove}
                >
                    <span className="fa fa-remove" aria-hidden="true" />
                    <span className="sr-only">Remove Date</span>
                </button>
            }
        </div>
    );
}

DateTimePicker.propTypes = propTypes;
DateTimePicker.defaultProps = defaultProps;

export default DateTimePicker;